import { useState, useEffect } from 'react';
import randomKey from '../node_modules/warbler/dist/number/random-key.js';

const useId = (prefix = 'component', propId) => {
    const [id, setId] = useState(propId);
    useEffect(() => {
        if (!id)
            setId(`${prefix}-${randomKey(15)}`);
    }, []);
    return id;
};

export { useId as default };
